const PREFIX = 'slider-nav';

export const SPARTAN_SLIDER_NAV_TRACKING = {
  root: PREFIX,
  prev: `${PREFIX}-prev`,
  next: `${PREFIX}-next`,
} as const;
